import {
  Box,
  Button,
  Center,
  Circle,
  Flex,
  Heading,
  Img,
  Square,
  Text,
  Wrap,
} from "@chakra-ui/react";
import React, { useEffect, useLayoutEffect, useState } from "react";
import moment from "moment";
import salary from "../../../Assets/salary_icon.svg";
import map from "../../../Assets/map_icon.png";
import saveIcon from "../../../Assets/saveIcon.svg";
import saveIcon2 from "../../../Assets/save-2.svg";
import jobtypePic from "../../../Assets/briefcase.svg";
import Badge_Component from "../Badge/Badge_Component";
import defaultProfilePic from "Assets/defaultlogo.png";
import monitor from "../../../Assets/monitor.svg";
import people from "../../../Assets/people.svg";
import * as api from "../../../services/api";
import { removeEmptyHTMLTags } from "helper/helper";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router";
import arrowCircle from "Assets/arrowCircle.svg";
import { useNavigate, useParams } from "react-router-dom";
import { useWindow } from "hooks/useWindow";
import BackButton from "Components/Back/BackButton";
import Swal from "sweetalert2";
import { postActions } from "redux/actions";
import { myApplicationFactory } from "helper/factory";
import useIsAuth from "hooks/useIsAuth";

const Details_Jobrole = ({
  postID,
  student,
  setPostID,
  appliedData,
  setAppliedData,
  setInvites,
  status,
  setMobileView,
  inviteId,
  setSavedPosts: setSavedPostsProp,
  posts,
  setPosts,
}) => {
  const levels = [
    "Foundation",
    "3D NFT Creator",
    "3D Environment Creator",
    "XR Interaction Creator",
    "Simulation Creator",
    "Ajna Creator",
  ];
  const location = useLocation();

  const [tab, setTab] = useState("");
  const [isSaved, setIsSaved] = useState(false);
  const [isSavedArray, setIsSavedArray] = useState([]);
  const [accepted, setAccepted] = useState("pending");
  const [isApplied, setIsApplied] = useState(false);
  const windowSize = useWindow();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [postData, setPostData] = useState({
    jobDescription: "",
    jobRoleTitle: "",
    jobType: "",
    location: "",
    requiredLevel: "",
    sector: "",
    openings: "",
    applyByDate: "",
    requiredLevel: "",
    jobType: "",
    status: "",
    companyID: {},
    inviteId: "",
    createdBy: {},
  });
  // console.log("postID", postID);

  const locationArr = location.pathname.split("/");
  // console.log(locationArr);
  const locationEndpoint = locationArr[locationArr.length - 1];
  const isAuth = useIsAuth();
  const { jobid } = useParams();

  const [savedPosts, setSavedPosts] = useState([]);
  const isaccepted = useSelector((state) => state.post?.accepted);
  // const [company, setCompany] = useState("")
  const [isClosed, setIsClosed] = useState(postData?.status === "inactive");
  const pathName = location.pathname.split("/").pop();
  useEffect(() => {
    const getPost = async () => {
      if (postID) {
        const post = await api.getJobById(
          postID,
          (pathName === "myapplication" && "status=true") ||
            (pathName === "invites" && "acceptStatus=true") ||
            ""
        );
        setPostData(post.data.data);
      }
    };
    getPost();
  }, [postID, location.pathname, isaccepted]);

  useEffect(() => {
    const getSavedposts = async () => {
      if (postID) {
        const savedpost = await api.getSavedPosts(postID);
        setSavedPosts(savedpost.data.data);
        setIsSaved(savedpost.data.data.some((post) => post._id === postID));
        setIsSavedArray(savedpost.data.data.map((post) => post._id));
      }
    };
    getSavedposts();
  }, [postID]);

  // console.log("saved posts", savedPosts);

  useEffect(() => {
    if (!student) {
      if (postData?.status) {
        setIsClosed(postData.status === "inactive");
      }
    }
  }, [postData]);
  const closeHandler = async () => {
    if (!student) {
      if (!isClosed) {
        await api.changeJobStatus("inactive", postData._id);
        setIsClosed(true);
      }
    }
  };

  const applyFn = async () => {
    if (!isAuth) {
      Swal.fire({
        icon: "info",
        title: "Please Login to Apply",
        showCancelButton: true,
        confirmButtonText: "Login",
        cancelButtonText: "Cancel",
        confirmButtonColor: "#6c56fb",
      }).then((result) => {
        if (result.isConfirmed) {
          navigate("/#" + "?redirect=" + location.pathname);
        }
      });
      return;
    }
    const response = await api.applyToJob(postID);
    if (response.status === 200) {
      setIsApplied(true);
    }
  };
  const saveHandler = async () => {
    if (!isAuth) {
      Swal.fire({
        icon: "info",
        title: "Please Login to Save",
        showCancelButton: true,
        confirmButtonText: "Login",
        cancelButtonText: "Cancel",
        confirmButtonColor: "#6c56fb",
      }).then((result) => {
        if (result.isConfirmed) {
          navigate("/#" + "?redirect=" + location.pathname);
        }
      });
      return;
    }

    if (isSavedArray?.includes(postID)) {
      Swal.fire({
        icon: "error",
        title: "Are you sure to remove this job from your saved jobs?",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then(async (result) => {
        if (result.isConfirmed) {
          await api.saveOrRemoveSavedPost(postID);
          setIsSaved(false);
          Swal.fire({
            icon: "success",
            title: "Job Removed",
            timer: 1500,
          });
          setPostID("");
          setIsSavedArray((prev) => prev?.filter((post) => post !== postID));
          setSavedPostsProp((prev) =>
            prev?.filter((post) => post._id !== postID)
          );
          setIsSaved(!isSaved);
        }
        return;
      });
      return;
    }
    if (!isSavedArray?.includes(postID)) {
      await api.saveOrRemoveSavedPost(postID);
      setIsSavedArray((prev) => [...prev, postID]);
      // to make save job toggable uncomment below code
      setIsSaved(!isSaved);
      setAppliedData((prev) => [...prev, postID]);
      Swal.fire({
        icon: "success",
        title: "Job Saved",
        timer: 1500,
      });
    }
  };

  const sliceText = (text) => {
    if (text?.length >= 16) {
      const sliced = text.slice(0, 15);
      return `${sliced}...`;
    }
    return text;
  };
  const renderInMarker = (text) => {
    const markers = [];
    const result = text?.replace(/(\(.*?\))/g, (match, p1, offset) => {
      markers.push({ offset, length: p1.length });
      return p1;
    });
    return { result, markers };
  };

  useEffect(() => {
    const { result } = renderInMarker(postData?.jobDescription);
    if (
      postData?.jobDescription &&
      document.getElementById("readMore") &&
      result
    ) {
      document.getElementById("readMore").innerText = result;
    }
  }, [postData?.jobDescription]);

  const arr = [1, 2, 3, 4];
  function isHTML(str) {
    var doc = new DOMParser().parseFromString(str, "text/html");
    return Array.from(doc.body.childNodes).some((node) => node.nodeType === 1);
  }

  const acceptFn = async (inviteId, status) => {
    try {
      if (status === "rejected") {
        Swal.fire({
          icon: "warning",
          title: "Are you sure?",
          text: "You want to reject this invite?",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        })
          .then(async (result) => {
            if (result.isConfirmed) {
              const response = await api.changeStatusOfInvite(inviteId, status);
              if (response.status === 200) {
                setMobileView(false);
                const { data } = await api.getAllInvitesForStudent();
                const modifiedData = data?.data?.data.map((item) => {
                  return myApplicationFactory(
                    item?.hiringPostId,
                    item?.status,
                    item?._id
                  );
                });
                setInvites(modifiedData);
                setPostID("");
                dispatch(postActions?.acceptJob());
              }
            }
            return;
          })
          .catch((err) => {
            console.log(err);
          });
      }
      if (status === "accepted") {
        const response = await api.changeStatusOfInvite(inviteId, status);
        if (response.status === 200) {
          setPostID("");
          dispatch(postActions?.acceptJob());
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  // useLayoutEffect(() => {
  //   window.scrollTo(0, 0);
  // }, []);
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <>
      {/* Container */}
      <Box
        borderRight={["none", "none", "none", "1px solid #E4E4E4"]}
        css={
          !student
            ? {
                "@media  (min-width:1540px) and (max-width: 1980px)": {
                  maxW: 600,
                },
                "@media (max-width: 1540px)": {
                  width: student ? "100%" : 570,
                },
                "@media (max-width: 480px)": {
                  width: "100%",
                },
              }
            : { width: "100%" }
        }
        px={[1, 1, 4, 4]}
        py={[2, 2, 4, 4]}
        // ml={[0, 0, 10, 10]}
      >
        {/* head */}
        {windowSize < 480 && student && (
          <div
            style={{
              marginBottom: "0.5rem",
              marginTop: "2rem",
              display: jobid ? "none" : "block",
            }}
            onClick={() => setMobileView(false)}
          >
            <BackButton />
          </div>
        )}
        <Box>
          <Flex justify="space-between" align="center">
            {/* first half */}
            <Flex align="center" gap={[1, 1, 5, 5]}>
              <Square
                size={[51]}
                p={1}
                border={"1px solid #e4e4e4"}
                borderRadius={12}
              >
                <img
                  height={"100%"}
                  width={"100%"}
                  src={postData?.companyID?.profilePhoto}
                  onError={(e) => (e.target.src = defaultProfilePic)}
                  alt="logo"
                />
              </Square>
              <Box>
                <Text
                  fontSize={[16, 16, 20, 20]}
                  fontWeight={500}
                  fontFamily={"Roboto"}
                  textAlign="left"
                >
                  {postData?.jobRoleTitle}
                </Text>
                <Text
                  textAlign="left"
                  fontSize={14}
                  fontWeight={400}
                  color={"#9D99A3"}
                  fontFamily={"Roboto"}
                >
                  {postData?.companyID?.companyName}
                </Text>
              </Box>
            </Flex>
            {/* second half */}
            {!student && (
              <Flex gap={2}>
                <Button
                  borderRadius={50}
                  bg="#D9D9D9"
                  fontSize={16}
                  fontWeight={500}
                  fontFamily={"Roboto"}
                  onClick={closeHandler}
                >
                  {isClosed ? "Closed" : "Close"}
                </Button>
              </Flex>
            )}
            {((student && locationEndpoint == "findjob") ||
              locationEndpoint === "savejobs") && (
              <Flex gap={2} align={"center"}>
                {windowSize > 480 && (
                  <Button
                    borderRadius={12}
                    bg="#6c56fb"
                    fontSize={[14, 14, 16, 16]}
                    fontWeight={500}
                    px={[4, 4, 10, 10]}
                    pointerEvents={
                      isApplied || appliedData?.includes(postID) ? "none" : null
                    }
                    color={"white"}
                    _hover={{
                      cursor:
                        isApplied || appliedData?.includes(postID)
                          ? "auto"
                          : "pointer",
                      boxShadow: "0px 8px 24px rgba(108, 86, 251, 0.2)",
                    }}
                    fontFamily={"Roboto"}
                    onClick={() =>
                      isApplied || appliedData?.includes(postID)
                        ? null
                        : applyFn()
                    }
                  >
                    {isApplied || appliedData?.includes(postID)
                      ? "Applied"
                      : "Apply"}
                  </Button>
                )}

                {/* save job */}
                <Circle
                  size={9}
                  cursor={"pointer"}
                  onClick={saveHandler}
                  border={"1px solid #DDDDDD"}
                >
                  <img
                    style={{ height: "50%", width: "50%", color: "white" }}
                    src={isSaved ? saveIcon2 : saveIcon}
                    alt="save"
                  />
                </Circle>
              </Flex>
            )}
            {jobid && (
              <Flex gap={2} align={"center"}>
                {windowSize > 480 && (
                  <Button
                    borderRadius={12}
                    display={
                      JSON.parse(localStorage.getItem("user"))?.profile ===
                        "recruiter" && "none"
                    }
                    bg="#6c56fb"
                    pointerEvents={
                      isApplied || appliedData?.includes(postID) ? "none" : null
                    }
                    fontSize={[14, 14, 16, 16]}
                    fontWeight={500}
                    px={[4, 4, 10, 10]}
                    color={"white"}
                    _hover={{
                      cursor:
                        isApplied || appliedData?.includes(postID)
                          ? "auto"
                          : "pointer",
                      boxShadow: "0px 8px 24px rgba(108, 86, 251, 0.2)",
                    }}
                    fontFamily={"Roboto"}
                    onClick={() =>
                      isApplied || appliedData?.includes(postID)
                        ? null
                        : applyFn()
                    }
                  >
                    {isApplied || appliedData?.includes(postID)
                      ? "Applied"
                      : "Apply"}
                  </Button>
                )}

                {/* save job */}
                <Circle
                  size={9}
                  cursor={"pointer"}
                  display={
                    (JSON.parse(localStorage.getItem("user"))?.profile ===
                      "recruiter" &&
                      "none") ||
                    "flex"
                  }
                  onClick={saveHandler}
                  border={"1px solid #DDDDDD"}
                >
                  <img
                    style={{ height: "50%", width: "50%", color: "white" }}
                    src={isSaved ? saveIcon2 : saveIcon}
                    alt="save"
                  />
                </Circle>
              </Flex>
            )}
            {student && locationEndpoint === "myapplication" && (
              // <Button isDisabled={true} buttonContent={status} style={{color:"red"}} />
              <Box
                px={[2, 2, 4, 4]}
                w={[28, 28, "fit-content", "fit-content"]}
                py={[1, 1, 2, 2]}
                borderRadius={40}
                fontSize={16}
                fontWeight={500}
                display={["block", "block", "block", "block"]}
                bg={
                  (postData &&
                    postData?.status
                      ?.toLocaleLowerCase()
                      ?.includes("intouch") &&
                    "rgba(255, 206, 1, 0.14)") ||
                  (postData?.status?.toLocaleLowerCase()?.includes("hired") &&
                    "rgba(0, 212, 174, 0.14)") ||
                  (postData?.status
                    ?.toLocaleLowerCase()
                    ?.includes("rejected") &&
                    "rgba(255, 89, 94, 0.14)")
                }
                color={
                  "#000"
                  // (postData?.status?.toLocaleLowerCase()?.includes("intouch") &&
                  //   "#FFCE01") ||
                  // (postData?.status?.toLocaleLowerCase()?.includes("hired") &&
                  //   "#00D4AE") ||
                  // (postData?.status
                  //   ?.toLocaleLowerCase()
                  //   ?.includes("rejected") &&
                  //   "#FF595E")
                }
              >
                {(postData?.status === "inTouch" && "In Touch") ||
                  (postData?.status === "hired" && "Hired") ||
                  (postData?.status
                    ?.toLocaleLowerCase()
                    ?.includes("rejected") &&
                    "Rejected")}
              </Box>
            )}
            {student && locationEndpoint == "invites" && (
              <Flex gap={1}>
                {accepted === "accepted" ||
                  (postData?.status === "accepted" && windowSize > 480 && (
                    <Button
                      borderRadius={12}
                      bg="#6c56fb"
                      fontSize={16}
                      fontWeight={500}
                      px={10}
                      color={"white"}
                      _hover={{
                        boxShadow: "0px 8px 24px rgba(108, 86, 251, 0.2)",
                      }}
                      fontFamily={"Roboto"}
                      onClick={() => acceptFn(postData?.inviteId, "accepted")}
                    >
                      {accepted === "accepted" ||
                      postData?.status === "accepted"
                        ? "Accepted"
                        : "Accept"}
                    </Button>
                  ))}
                <Circle
                  size={9}
                  cursor={"pointer"}
                  onClick={saveHandler}
                  border={"1px solid #DDDDDD"}
                >
                  <img
                    style={{ height: "50%", width: "50%", color: "white" }}
                    src={isSaved ? saveIcon2 : saveIcon}
                    alt="save"
                  />
                </Circle>
              </Flex>
            )}
          </Flex>
          {/* posted on apply by */}

          <Flex my={2} gap={4} justify="space-between" mt={23}>
            <Flex
              // display={["block", "block", "flex", "flex"]}
              align="center"
              gap={2}
            >
              <Text
                fontFamily={"Roboto"}
                fontWeight={500}
                color="#767676"
                fontSize={14}
              >
                Posted on :
              </Text>
              <Text
                fontSize={14}
                fontFamily={"Roboto"}
                fontWeight={500}
                color="#767676"
              >
                {moment(postData?.createdAt).format("DD-MM-YYYY")}
              </Text>
            </Flex>
            <Flex
              // display={["block", "block", "flex", "flex"]}
              align="center"
              gap={2}
            >
              <Text
                fontFamily={"Roboto"}
                fontSize={14}
                fontWeight={500}
                color="#767676"
              >
                Apply by :
              </Text>
              <Text
                fontSize={14}
                fontWeight={500}
                fontFamily={"Roboto"}
                color="#767676"
              >
                {moment(postData?.applyByDate).format("DD-MM-YYYY")}
              </Text>
            </Flex>
          </Flex>
          {/* Badge */}
          {windowSize > 480 && (
            <Box my={7}>
              <Wrap>
                <Badge_Component num={levels[postData?.requiredLevel]} />
              </Wrap>
            </Box>
          )}
          {/* Badges for student side */}
          {windowSize < 480 && locationEndpoint !== "myapplication" && (
            <Flex justify={"space-between"} py={4}>
              <Wrap>
                <Badge_Component num={levels[postData?.requiredLevel]} />
              </Wrap>

              {locationEndpoint !== "invites" && student && (
                <Button
                  borderRadius={8}
                  bg="#6c56fb"
                  fontSize={[14, 14, 16, 16]}
                  fontWeight={400}
                  px={[8, 8, 10, 10]}
                  color={"white"}
                  _hover={{
                    boxShadow: "0px 8px 24px rgba(108, 86, 251, 0.2)",
                  }}
                  fontFamily={"Roboto"}
                  onClick={applyFn}
                >
                  {isApplied || appliedData?.includes(postID)
                    ? "Applied"
                    : "Apply"}
                </Button>
              )}
            </Flex>
          )}

          {windowSize < 480 && locationEndpoint === "myapplication" && (
            <Flex justify={"space-between"} py={4}>
              <Wrap>
                <Badge_Component num={levels[postData?.requiredLevel]} />
              </Wrap>

              <Flex
                borderRadius={8}
                // bg="#6c56fb"
                fontSize={[14, 14, 16, 16]}
                fontWeight={400}
                align={"center"}
                justify={"center"}
                color={"#6C56FB"}
                px={"28px"}
                py={"6px"}
                border={"1px solid #6C56FB "}
                _hover={{
                  boxShadow: "0px 8px 24px rgba(108, 86, 251, 0.2)",
                }}
                fontFamily={"Roboto"}
                // onClick={applyFn}
              >
                {/* {isApplied || appliedData?.includes(postID)
                      ? "Applied"
                      : "Apply"} */}
                Applied
              </Flex>
            </Flex>
          )}
          {/* salary,location,opening,platform, jobtype */}
          <Box
            overflowX={"scroll"}
            css={{
              "::-webkit-scrollbar": {
                width: 0,
                height: 0,
              },
            }}
          >
            <Flex
              bg="#FFFFFF"
              borderRadius="20px"
              overflowX={"scroll"}
              border={"1px solid #E7E6E8"}
              css={{
                "::-webkit-scrollbar": {
                  width: 0,
                  height: 0,
                },
              }}
            >
              <Box flex="1" borderColor="#E7E6E8" p={[4, 4, 2, 2]}>
                <Flex
                  align="center"
                  justify="center"
                  px="2"
                  gap={"5px"}
                  bg="#FFFFFF"
                >
                  <img src={salary} alt="salary" />
                  <Text
                    fontSize={["14px", "14px", "16px", "16px"]}
                    fontFamily={"Roboto"}
                    fontWeight="500"
                    color="#767676"
                  >
                    Salary
                  </Text>
                </Flex>
                <Text
                  fontSize={["14px", "14px", "16px", "16px"]}
                  fontFamily={"Roboto"}
                  fontWeight="600"
                  color="#6D6675"
                >
                  {postData?.packageOffered} LPA
                </Text>
              </Box>

              <Box
                flex="1"
                borderLeftWidth="1px"
                borderRightWidth="1px"
                borderColor="#E7E6E8"
                p={[4, 4, 2, 2]}
              >
                <Flex
                  align="center"
                  justify="center"
                  px="2"
                  gap={"5px"}
                  bg="#FFFFFF"
                >
                  <img src={map} alt="location" />
                  <Text
                    fontSize={["14px", "14px", "16px", "16px"]}
                    fontFamily={"Roboto"}
                    fontWeight="500"
                    color="#767676"
                  >
                    Location
                  </Text>
                </Flex>
                <Text
                  fontSize={["14px", "14px", "16px", "16px"]}
                  fontFamily={"Roboto"}
                  fontWeight="600"
                  color="#6D6675"
                >
                  {sliceText(postData?.location)}
                </Text>
              </Box>

              <Box
                flex="1"
                borderRightWidth="1px"
                borderColor="#E7E6E8"
                p={[4, 4, 2, 2]}
              >
                <Flex
                  align="center"
                  justify="center"
                  px="2"
                  gap={"5px"}
                  bg="#FFFFFF"
                >
                  <img src={monitor} alt="opening" />
                  <Text
                    fontSize={["14px", "14px", "16px", "16px"]}
                    fontFamily={"Roboto"}
                    fontWeight="500"
                    color="#767676"
                  >
                    Platform
                  </Text>
                </Flex>
                <Text
                  fontSize={["14px", "14px", "16px", "16px"]}
                  fontFamily={"Roboto"}
                  fontWeight="600"
                  color="#6D6675"
                  textTransform={"capitalize"}
                >
                  {postData?.platform}
                </Text>
              </Box>

              <Box
                flex="1"
                borderRightWidth="1px"
                borderColor="#E7E6E8"
                p={[4, 4, 2, 2]}
              >
                <Flex
                  align="center"
                  justify="center"
                  px="2"
                  gap={"5px"}
                  bg="#FFFFFF"
                >
                  <img src={people} alt="opening" />
                  <Text
                    fontSize={["14px", "14px", "16px", "16px"]}
                    fontFamily={"Roboto"}
                    fontWeight="500"
                    color="#767676"
                  >
                    Openings
                  </Text>
                </Flex>
                <Text
                  fontSize={["14px", "14px", "16px", "16px"]}
                  fontFamily={"Roboto"}
                  fontWeight="600"
                  color="#6D6675"
                >
                  {postData?.openings}
                </Text>
              </Box>

              <Box
                flex="1"
                borderColor="#E7E6E8"
                borderRadius="0 20px 20px 0"
                p={[4, 4, 2, 2]}
              >
                <Flex
                  align="center"
                  justify="center"
                  px="2"
                  minW={105}
                  gap={"5px"}
                  bg="#FFFFFF"
                >
                  <img src={jobtypePic} alt="opening" />
                  <Text
                    fontSize={["14px", "14px", "16px", "16px"]}
                    fontFamily={"Roboto"}
                    fontWeight="500"
                    color="#767676"
                  >
                    Job Type
                  </Text>
                </Flex>
                <Text
                  fontSize={["14px", "14px", "16px", "16px"]}
                  fontFamily={"Roboto"}
                  fontWeight="600"
                  color="#6D6675"
                  textTransform={"capitalize"}
                >
                  {(postData?.jobType.includes("fullTime") && "Full Time") ||
                    (postData?.jobType.includes("partTime") && "Part Time") ||
                    (postData?.jobType.includes("wfh") && "Freelance")}
                </Text>
              </Box>
            </Flex>
          </Box>

          {windowSize < 480 && locationEndpoint === "invites" && (
            <Flex
              my={5}
              gap={8}
              justifyContent={
                accepted === "accepted" ||
                (postData?.status === "accepted" && "flex-end")
              }
            >
              {accepted === "pending" && postData?.status !== "accepted" && (
                <Button
                  w={"45%"}
                  justify={"center"}
                  align={"center"}
                  py={"8px"}
                  borderRadius={8}
                  fontFamily={"Roboto"}
                  fontWeight={500}
                  _disabled={{ bg: "#fff", color: "#4E4E4E" }}
                  fontSize={14}
                  border={"1px solid #CECCD1"}
                  onClick={() => acceptFn(postData?.inviteId, "rejected")}
                >
                  Not Interested
                </Button>
              )}

              <Flex
                w={"45%"}
                justify={"center"}
                align={"center"}
                py={"8px"}
                borderRadius={8}
                fontFamily={"Roboto"}
                fontWeight={500}
                fontSize={14}
                border={"1px solid #CECCD1"}
                bg={"#6C56FB"}
                _hover={{
                  boxShadow: "0px 8px 24px rgba(108, 86, 251, 0.2)",
                }}
                onClick={() => acceptFn(postData?.inviteId, "accepted")}
                color={"#fff"}
              >
                {accepted === "accepted" || postData?.status === "accepted"
                  ? "Accepted"
                  : "Accept"}
              </Flex>
            </Flex>
          )}

          {/* Title */}
          <Text
            fontSize={["16px", "16px", "18px", "18px"]}
            fontWeight={500}
            fontFamily={"Roboto"}
            color="#4E4E4E"
            textAlign="left"
            my={2}
          >
            Job description :
          </Text>
          {/* Job Description */}
          <Box
            px={["1rem", "1rem", "1rem", "1rem"]}
            css={{
              "@media screen and (max-width:480px)": {
                paddingLeft: "1rem",
                paddingRight: "1rem",
              },
            }}
            w={"100%"}
          >
            <div
              style={{
                paddingBottom: 3,
                // overflow: "auto",
                textAlign: "initial",
              }}
            >
              {/* text */}
              {isHTML(postData?.jobDescription) && (
                <div
                  id="readMore2"
                  dangerouslySetInnerHTML={{
                    __html: `<div>${removeEmptyHTMLTags(
                      postData.jobDescription
                    )}</div>`,
                  }}
                ></div>
              )}
              {!isHTML(postData?.jobDescription) && <div id="readMore"></div>}
            </div>
          </Box>
        </Box>
        {/* posted by */}
        <Box>
          <Flex>
            <Heading
              paddingTop={2}
              size={"md"}
              color={"#4E4E4E"}
              fontWeight={"500"}
              fontFamily={"Roboto"}
              fontSize={["16px", "16px", "18px", "18px"]}
            >
              Posted By:
            </Heading>
          </Flex>
          <Flex
            align="center"
            gap={2}
            my={5}
            border={"1px solid #DDDDDD"}
            padding={2}
            borderRadius={15}
          >
            <Circle size={[12, 12, 14, 14]} p={1} border={"1px solid #DDDDDD"}>
              <img
                src={postData?.createdBy?.profile_photo}
                alt="company"
                onError={(e) => {
                  return (e.target.src = defaultProfilePic);
                }}
                className="radius-50"
                style={{ width: "100%", height: "100%" }}
              />
            </Circle>

            <Flex direction="column">
              <Text
                textAlign={"left"}
                color={"#6D6675"}
                fontWeight={"bold"}
                textTransform={"capitalize"}
              >
                {postData?.createdBy.name}
              </Text>
              <Flex>
                <Text color={"#6D6675"}>{postData?.createdBy?.jobTitle}</Text>
              </Flex>
            </Flex>
          </Flex>
        </Box>
        <Box>
          <Flex>
            <Heading
              paddingTop={2}
              size={"md"}
              color={"#4E4E4E"}
              fontWeight={"500"}
              fontFamily={"Roboto"}
              fontSize={["16px", "16px", "18px", "18px"]}
            >
              About Company:
            </Heading>
          </Flex>
          <Box border={"1px solid #DDDDDD"} borderRadius={15} my={5}>
            <Flex
              align="center"
              gap={2}
              padding={2}
              justifyContent={"space-between"}
            >
              <Flex align={"center"} gap={"12px"}>
                <Circle
                  size={[12, 12, 14, 14]}
                  p={1}
                  border={"1px solid #DDDDDD"}
                >
                  <img
                    src={postData?.companyID?.profilePhoto}
                    alt="company"
                    onError={(e) => (e.target.src = defaultProfilePic)}
                    className="radius-50"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                    }}
                  />
                </Circle>
                <Flex direction="column" px={1}>
                  <Text
                    textAlign={"left"}
                    color={"#000"}
                    fontWeight={600}
                    fontSize={["16px", "16px", "18px", "18px"]}
                    fontFamily={"Roboto"}
                    textTransform={"capitalize"}
                  >
                    {postData?.companyID?.companyName}
                    {/* Spatial */}
                  </Text>
                  <Text
                    textAlign={"left"}
                    color={"#6D6675"}
                    fontSize={["12px", "12px", "14px", "14px"]}
                  >
                    {postData?.companyID?.companyAddress?.split("_")?.join(" ")}
                  </Text>
                </Flex>
              </Flex>
              {student && locationEndpoint === "findjob" && (
                <Flex display={["none", "none", "flex", "flex"]}>
                  <Img
                    src={arrowCircle}
                    alt="arrow"
                    width={30}
                    height={30}
                    cursor={"pointer"}
                    onClick={() => {
                      navigate(`?company=${postData?.companyID?._id}`);
                    }}
                  />
                </Flex>
              )}
            </Flex>
            <Flex>
              <Text
                color={"#6D6675"}
                textAlign={"left"}
                width={"100%"}
                p={2}
                px={4}
                fontSize={["14px", "14px", "16px", "16px"]}
              >
                {postData?.companyID?.bio}
              </Text>
            </Flex>
          </Box>
        </Box>
      </Box>
    </>
  );
};
export default Details_Jobrole;
